import {
  casinoEnabled,
  esportsEnabled,
  sportsbookEnabled
} from 'utils/constants/app/general';
import { ESearchElementSearchType } from 'newelements/SearchElement/partials/types';

export const getSearchType = (): ESearchElementSearchType => {
  if (casinoEnabled && sportsbookEnabled) {
    return ESearchElementSearchType.ALL;
  }

  if (esportsEnabled) {
    return ESearchElementSearchType.ESPORT;
  }

  if (sportsbookEnabled) {
    return ESearchElementSearchType.SPORT;
  }

  if (casinoEnabled) {
    return ESearchElementSearchType.CASINO;
  }

  return ESearchElementSearchType.ALL;
};
